import type { PspRules } from "@CommonTypes/backend/PspRules";

type UnitsTooMany = PspRules["relax_factors"]["units_too_many"];

export const getUnitsTooManyLimit = (value: UnitsTooMany): number =>
  typeof value === "number" ? value : value.max_relaxation;

/**
 * Keeps a stepped rule's pricing up to the new limit: the step the limit falls in ends at the limit
 * and steps past it go, as the backend rejects them. A step must end above 0, so a limit of 0 has none.
 */
export const withUnitsTooManyLimit = (value: UnitsTooMany, limit: number): UnitsTooMany => {
  if (typeof value === "number") return limit;
  const sorted = [...(value.steps ?? [])].sort((a, b) => a.up_to - b.up_to);
  const below = sorted.filter((step) => step.up_to < limit);
  const crossing = sorted.find((step) => step.up_to >= limit);
  const steps = crossing && limit > 0 ? [...below, { ...crossing, up_to: limit }] : below;
  return { ...value, max_relaxation: limit, steps: steps.length ? steps : undefined };
};
